import { makeStyles } from '@mui/styles';

const useLogoStyles = makeStyles({
	root: {
		alignItems: 'center',
		display: 'flex',
		gap: 8,
		width: '100%',
	},
	icon: {
		height: 48,
		width: 48,
	},
	pageTitle: {
		color: 'white',
		fontFamily: 'Montserrat',
		fontSize: 10,
		fontWeight: 300,
		letterSpacing: '0.62px',
		lineHeight: 1,
		margin: 0,
		padding: 0,
		textTransform: 'uppercase',
	},
});

export default useLogoStyles;
